import { DiagramModel, LinkModel } from "storm-react-diagrams";
import { createWidget } from "./widgets";
import { CustomNodeModel } from "./widgets/CustomNodeModel";
import { CustomLinkModel } from "designer/widgets/CustomLinkFactory";

export function serialize(model: DiagramModel) {
  const data = model.serializeDiagram();
  const linksDict = data.links.reduce((o, s) => {
    o[s.id] = s;
    return o;
  }, {});

  const output: SerializedGraph = data.nodes.map(node => ({
    ...node.extras,
    id: node.id,
    x: Math.floor(node.x),
    y: Math.floor(node.y),
    height: node.extras.height || 200,
    width: node.extras.width || 80,
    type: node.extras.type,
    q: node.extras.q,
    sub: node.extras.sub || "main",
    telemetryid: node.extras.telemetryid || "",
    nextq: "",
    allowFeedback: node.extras.allowFeedback || false,
  }));

  data.nodes.forEach((node, i) => {
    // tslint:disable no-string-literal
    const nextq = node.ports
      .filter(p => !p["in"])
      .map(p =>
        p.links.map(linkId => {
          const link = linksDict[linkId];
          const linkedNode = link.target;
          const q = output.findIndex(n => n.id === linkedNode && (n.type === "ChoiceAction" || n.id !== node.id));
          return {
            ...link.extras,
            q
          };
        })
      )
      .reduce((s, v) => [...s, ...v], [])
      .filter(l => l.q !== -1);
    output[i].nextq = nextq.length > 0 ? JSON.stringify(nextq) : "-1";
  });

  // Temporary fix to reduce JSON size
  output.forEach(n => {
    // delete n.id
  });

  return output;
}

export function deserialize(json: string): DiagramModel {
  let graph;
  try {
    graph = JSON.parse(json) as SerializedGraph;
  } catch (e) {
    return new DiagramModel();
  }
  const model = new DiagramModel();
  model.setOffset(400, 0);
  const nodes: CustomNodeModel[] = [];
  graph.forEach(n => {
    const node = createWidget(model, n.type, n.id);
    node.extras = n;
    node.setPosition(n.x, n.y);
    nodes.push(node);
  });
  nodes.filter(n => n.extras.nextq !== "-1").forEach(n => {
    const nextq = JSON.parse(n.extras.nextq) as NextQ[];
    nextq.filter(l => nodes[l.q]).forEach(l => {
      const inPort = n.getOutPorts()[0];
      const outPort = nodes[l.q].getInPorts()[0];
      const link = inPort.link(outPort) as CustomLinkModel;
      link.extras = l;
      normalizeLinkValues(link);
      if (l.choice) {
        link.addLabel(l.choice);
      }
      model.addLink(link);
    });
  });

  return model;
}
export type SerializedGraph = SerializeGraphNode[];
export interface SerializeGraphNode {
  id?: string;
  x: number;
  y: number;
  width?: number;
  height?: number;
  type: string;
  nextq: string;
  q: string;
}
export interface NextQ {
  q: number;
  choice?: string;
}

function normalizeLinkValues(link: LinkModel) {
  [ "choice", "choiceValue", "speak", 
    "alternateIntents", "alternateEntities", 
    "alternateKeywords", "url", "imageUrl", "order" ]
    .filter(field => link.extras[field] === undefined || link.extras[field] === null)
    .forEach(field => {
      link.extras[field] = "";
    });
}


// WEBPACK FOOTER //
// ./src/designer/serializer.ts